"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldReturnPDF = exports.shouldReturnText = exports.isCSV = exports.encodeQueryData = void 0;
var encodeQueryData = function (data) {
    var ret = [];
    for (var d in data) {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    }
    return ret.join('&');
};
exports.encodeQueryData = encodeQueryData;
var isCSV = function (options) {
    var accept = options.headers && options.headers['Accept'];
    return accept && accept.indexOf('text/csv') > -1;
};
exports.isCSV = isCSV;
var CSV_TYPE = /text\/csv/i;
var RAW_TYPE = /text\/(html|csv)/i;
var shouldReturnText = function (response, options) {
    if (CSV_TYPE.test(options.headers['Accept'] || '')) {
        return true;
    }
    if (RAW_TYPE.test(response.headers.get('content-type'))) {
        return true;
    }
    return false;
};
exports.shouldReturnText = shouldReturnText;
var PDF_TYPE = /application\/pdf/i;
var shouldReturnPDF = function (response, options) {
    if (PDF_TYPE.test(options.headers['Accept'] || '')) {
        return true;
    }
    return false;
};
exports.shouldReturnPDF = shouldReturnPDF;
//# sourceMappingURL=utils.js.map